import { FunctionComponent } from 'react'

import { useAuthContext } from 'auth/context/useAuthContext'

export const PrivateRoute: FunctionComponent<any> = ({ children }) => {
  const { jwt, isAuthenticated } = useAuthContext()

  // Only display routes if token present and user is authenticated
  return jwt && isAuthenticated ? children : null
}
